<script lang="ts">
  import { page } from '@inertiajs/svelte'

  const flash = $derived(
    $page.props.flash as { success?: string; error?: string; info?: string } | undefined
  )
</script>

{#if flash?.success}
  <div
    class="border-b border-[rgba(122,181,71,0.2)] bg-[#7AB547]/10 px-4 py-3 text-center text-sm text-white"
    role="status"
  >
    <span class="mr-1.5 text-[#7AB547]">✓</span>{flash.success}
  </div>
{/if}
{#if flash?.error}
  <div
    class="border-b border-red-500/20 bg-red-500/10 px-4 py-3 text-center text-sm text-red-300"
    role="alert"
  >
    <span class="mr-1.5">✕</span>{flash.error}
  </div>
{/if}
{#if flash?.info}
  <div
    class="border-b border-amber-500/20 bg-amber-500/10 px-4 py-3 text-center text-sm text-amber-300"
    role="status"
  >
    <span class="mr-1.5">ℹ</span>{flash.info}
  </div>
{/if}
